export default __webpack_public_path__ + "static/media/station-types-icon.a0ec5ea5.svg";